import { render, staticRenderFns } from "./FormConfirmTransferWallet.vue?vue&type=template&id=69bb0ebc&scoped=true&"
import script from "./FormConfirmTransferWallet.vue?vue&type=script&lang=js&"
export * from "./FormConfirmTransferWallet.vue?vue&type=script&lang=js&"
import style0 from "./FormConfirmTransferWallet.vue?vue&type=style&index=0&id=69bb0ebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bb0ebc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VForm,VIcon,VTextField})
